import { createAsyncThunk } from '@reduxjs/toolkit';

import type { AppState } from './root.reducer';
import type { AppDispatch } from './store';

export type NotificationConfig = {
    error?:
        | string
        | ((action: {
              error?: { message?: string };
              payload?: unknown;
          }) => string);
    success?: string | ((action: { payload?: unknown }) => string | undefined);
};

export const notificationRegistry = new Map<string, NotificationConfig>();

export function clearNotificationRegistry(): void {
    notificationRegistry.clear();
}

export const createAppAsyncThunk = createAsyncThunk.withTypes<{
    state: AppState;
    dispatch: AppDispatch;
}>();

export function createNotifiedThunk<Returned, ThunkArg = void>(
    typePrefix: string,
    payloadCreator: Parameters<
        typeof createAppAsyncThunk<Returned, ThunkArg>
    >[1],
    notifications: NotificationConfig,
    options?: Parameters<typeof createAppAsyncThunk<Returned, ThunkArg>>[2],
) {
    notificationRegistry.set(typePrefix, notifications);
    return createAppAsyncThunk<Returned, ThunkArg>(
        typePrefix,
        payloadCreator,
        options,
    );
}
